// Scatter axes accept any numeric measureKind from a material catalog
// entry. Derived / window / comparison columns are out -- their
// aggregation at non-leaf groupings is ambiguous.

import { COLUMN_CATALOG_MAP, getStatisticDisplay } from '../../../lib/constants'
import { effectiveFormat } from '../../../lib/effectiveFormat'

function getCatalog (columnInstance) {
  if (!columnInstance) return null
  return COLUMN_CATALOG_MAP[columnInstance.columnType] || null
}

export function isScatterEligible (columnInstance) {
  const catalog = getCatalog(columnInstance)
  if (!catalog) return false
  if (catalog.kind && catalog.kind !== 'material') return false
  if (!catalog.measureKind) return false
  return true
}

/** @returns Array<{ columnInstance, label, valueFormat, measureKind }> */
export function deriveAxisOptions (config, columnDefinitions, prefs) {
  const defsById = new Map((columnDefinitions || []).map(d => [d.accessorKey, d]))
  const out = []
  for (const col of config?.columns || []) {
    if (!isScatterEligible(col)) continue
    const def = defsById.get(col.id)
    const catalog = COLUMN_CATALOG_MAP[col.columnType]
    // groupStatistic instances differ by statisticType -- a Sharpe
    // Ratio is a ratio, a Standard Deviation is a return. Read the
    // per-statistic display so each axis formats correctly.
    const isStat = col.columnType === 'groupStatistic' || col.columnType === 'benchmarkStatistic'
    const statDisplay = isStat ? getStatisticDisplay(col.options?.statisticType) : null
    const format = def?.format ?? statDisplay?.format ?? catalog?.format
    const measureKind = def?.measureKind ?? statDisplay?.measureKind ?? catalog?.measureKind
    // Prefer headerFn(options) over the catalog's generic label so
    // catalog-injected instances differentiate (e.g., a groupStatistic
    // column with `statisticType: 'Sharpe Ratio'` shows as "Sharpe
    // Ratio" instead of the generic "Statistic"). headerFn outputs are
    // already used by the grid for the column headers, so labels stay
    // consistent across the table and the axis picker.
    const headerFn = typeof catalog?.headerFn === 'function' ? catalog.headerFn : null
    const optionLabel = headerFn ? headerFn(col.options || {}) : null
    out.push({
      columnInstance: col,
      label: def?.header || optionLabel || catalog?.label || col.columnType,
      valueFormat: effectiveFormat(format, measureKind, prefs),
      measureKind
    })
  }
  return out
}
